<form
  class="form-inline"
  name="uploadForm"
  #uf="ngForm"
  (ngSubmit)="uf.form.valid && onSubmit()">
  <div class="name">
    <label for="name">Name</label>
    <textarea
      pTextarea
      id="name"
      name="Name"
      [(ngModel)]="uploadTemplateModel.Name"
      ngDefaultControl
      #Name="ngModel"
      rows="2"
      cols="60"
      required>
    </textarea>

    @if (uf.submitted && Name.invalid) {
      <div class="c-error">
        @if (Name.errors && Name.errors['required']) {
          <div>Name field cannot be blank</div>
        }
      </div>
    }
  </div>
  <div class="descriptiopn">
    <label for="description">Description</label>
    <textarea
      pTextarea
      [(ngModel)]="uploadTemplateModel.Description"
      #Description="ngModel"
      ngDefaultControl
      id="description"
      name="description"
      rows="5"
      cols="60"
      required>
    </textarea>
    @if (uf.submitted && Description.invalid) {
      <div class="c-error">
        @if (Description.errors && Description.errors['required']) {
          <div>Description field cannot be blank</div>
        }
      </div>
    }
  </div>
  <button
    type="submit"
    pButton
    class="ui-button-primary excel-export btn-excel-first">
    <span> Upload </span>
  </button>
  @for (message of sucessmsg; track message) {
    <p-message [life]="3000" [text]="message.detail"></p-message>
  }
</form>

<p-dialog
  [(visible)]="loadUploadDialog"
  [contentStyle]="{
    'max-height': '550px',
    'overflow-y': 'auto',
    width: '700px',
    'z-index': '10027px'
  }"
  [focusOnShow]="false"
  [closable]="false"
  [draggable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="true">
  <ng-template #header>
    <div class="ui-g-11 upload-header">Upload Email Template</div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="cancelUploadDocument()"
      (keydown.enter)="cancelUploadDocument()"
      tabindex="0">
      <i class="mdl2-cancel cpointer" style="float: right; color: #212121"></i>
    </div>
  </ng-template>
  <div class="tolFile">
    <p><b>Note: </b>Drag and Drop/Browse files will be Uploaded to Server.</p>
  </div>
  @for (message of umsgs; track message) {
    <p-message [life]="3000" [text]="message.detail"></p-message>
  }
  <div
    class="uploadfilecontainer"
    [ngClass]="{ 'upload-disabled': disableUpload === true }"
    appDragDrop
    (onFileDropped)="dragDropUploadFile($event)"
    (click)="fileInputUpload.click()"
    (keydown.enter)="fileInputUpload.click()"
    tabindex="0">
    <div><i class="fa fa-cloud-upload fa-lg"></i></div>
    Drag and drop files here or <a class="file-browse">Browse</a>
    <input
      hidden
      type="file"
      #fileInputUpload
      (change)="uploadFile($any($event.target).files)" />
  </div>
  @if (filesUpload) {
    <div class="tolFile">
      <p>
        Total Number of File in Uploading:
        {{ filesUpload.length }}
      </p>
    </div>
  }
  <div class="files-list listtable">
    <table>
      <tr *ngFor="let file of filesUpload; let i = index">
        <td class="file-text">{{ file.name }}</td>
        <td class="tdwidth file-text">
          <span>{{ formatBytes(file?.size, 0) }}</span>
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
        <td class="tdwidth file-icon">
          @if (fileUploadSpinners) {
            <i class="fa fa-spinner fa-spin"></i>
          }
          @if (!fileUploadSpinners) {
            <i class="fa fa-check-circle-o"></i>
          }
        </td>
        <td class="tdwidth file-icon">
          <span
            (click)="removeSelectedFile()"
            (keydown.enter)="removeSelectedFile()"
            tabindex="0">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </span>
        </td>
      </tr>
    </table>
  </div>
  <br />
  <div style="text-align: right">
    <button
      type="submit"
      id="submitFile"
      (click)="submitSelectedFile()"
      class="flat btnmr"
      pButton>
      Submit
    </button>
    <button
      type="button"
      pButton
      (click)="cancelUploadDocument()"
      class="ui-button-secondary flat">
      Cancel
    </button>
  </div>
</p-dialog>
